import { render, staticRenderFns } from "./IconEssay.vue?vue&type=template&id=4e8b36ec&"
import script from "./IconEssay.vue?vue&type=script&lang=js&"
export * from "./IconEssay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports